export const GENDER = [
  { id: "Male", name: "Male" },
  { id: "Female", name: "Female" },
  { id: "Others", name: "Others" },
]
export const DEGREE_TYPE = {
  1: "+2",
  2: "Sub-overseer",
  3: "Overseer",
  4: "Bachelor",
  5: "Masters",
  6: "M.Phil",
}
export const AVAILABILITY = { 1: "Available", 2: "Not Available", 3: "Partial" }
export const SALARY_RANGE = {
  1: "10k-20k",
  2: "20k-30k",
  3: "30k-40k",
  4: "40k+",
}
export const WORK_TYPE = {
  1: "Intern",
  2: "Partial",
  3: "Part-time",
  4: "Full-time",
}
export const WORK_SHIFT = { 1: "Morning", 2: "Day", 3: "Evening", 4: "Night" }
export const SOCIAL_SITE = [
  { id: 1, name: "Facebook" },
  { id: 2, name: "Twitter" },
  { id: 3, name: "LinkedIn" },
  { id: 4, name: "Instagram" },
]

export const MONTHS = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
]

export const MONTHS_FULL = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
]
